import React from 'react'
import { SettingsSectionV2 } from './SettingsSectionV2'

/*
 * System → Integrations → Abstract API: the Email and Phone Validation
 * addresses and keys a new account is checked with at sign-up
 * (users.service addWelcomePackage → registerInfo). The keys are secrets:
 * admin_audit keeps only their last four characters. ABSTRACT_API_IP_* is
 * read nowhere, so it is not here.
 */
const GROUPS = [
  { key: 'abstract-email', title: 'Email validation', sub: 'Checks a new account’s email at sign-up' },
  { key: 'abstract-phone', title: 'Phone validation', sub: 'Checks a new account’s phone at sign-up' },
]

export function AbstractApiSettingsV2() {
  return (
    <SettingsSectionV2
      title="Abstract API"
      intro="The service new accounts’ email and phone are checked with at sign-up. A value saved here replaces the ConfigMap one and works without a restart."
      groups={GROUPS}
      saveNote={() => 'Used from the next sign-up.'}
    />
  )
}
